import {BehaviorSubject} from "rxjs";

export const meInitializedStatus$ = new BehaviorSubject(false)
